import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn's class combiner: clsx for conditionals + tailwind-merge to dedupe
 * conflicting Tailwind classes (last-wins). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
